
import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

interface TopNavigationProps {
  title?: string;
  showBack?: boolean;
  rightAction?: ReactNode;
  className?: string;
}

export default function TopNavigation({
  title,
  showBack = false,
  rightAction,
  className = ''
}: TopNavigationProps) {
  const navigate = useNavigate();

  return (
    <div className={`fixed top-0 left-0 right-0 bg-white border-b border-gray-200 z-50 ${className}`}>
      <div className="flex items-center justify-between h-14 px-4">
        <div className="flex items-center">
          {rightAction}
        </div>
        
        {title && (
          <h1 className="text-lg font-semibold text-gray-900 text-center flex-1 font-cairo">
            {title}
          </h1>
        )}
        
        <div className="flex items-center">
          {showBack && (
            <button
              onClick={() => navigate(-1)}
              className="p-2 -mr-2 text-gray-600 hover:text-gray-900"
            >
              <i className="ri-arrow-left-line text-xl w-6 h-6 flex items-center justify-center"></i>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
